import React from 'react';
import StyledBox from 'views/rebranded-module/common/components/UI/NewMainWidget/IconedBox/IconedBox.styles';

const IconedBox = (props) => {
  const {
    children, Icon, className, ...restOfProps
  } = props;
  return (
    <StyledBox className={`${className} IconedBoxContainer`} {...restOfProps}>
     {Icon && <Icon className="IBIcon" />} 
      {children}
    </StyledBox>
  );
};

export { IconedBox };
